module.exports = __webpack_public_path__ + "static/media/img94.9c63ce1d.jpg";